import type { SiteControllerSettingNeppanInput } from "@/lib/gql/__generated__/graphql";

import type { SiteControllerSettingNeppanFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingNeppanFormModel["ViewModel"];
};

export const viewModelToInput = ({ viewModel }: Props) => {
	const { hotelID, password, setUpRoomPriceByChillnn } = viewModel;

	const input: SiteControllerSettingNeppanInput = {
		hotelID,
		password: password?.value,
		setUpRoomPriceByChillnn: setUpRoomPriceByChillnn?.value,
	} satisfies SiteControllerSettingNeppanInput;

	return input;
};
